import user from './user'
import management from './management'
import dashboard from './dashboard'
import resumes from './resumes'
import subscript from './subscript'
import statistics from './statistics'
import recruit from './recruit'
import banner from './banner'
import train from './train'
export default{
  user,
  management,
  dashboard,
  resumes,
  subscript,
  statistics,
  recruit,
  banner,
  train
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js